import { connect } from "react-redux"
import FacilityAssets from "."
import qs from "query-string"
import { graphql } from "react-apollo"
import PropTypes from "prop-types"
import gql from "graphql-tag"

const query = gql`
  query FacilityAssets($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      assets(tagged: true) {
        id
        assetId
        batteryStatus
        serialNumber
        name
        labels
        hwid
        manufacturer
        modelName
        ownership
        lastMovedAt
        lastSeenAt
        owners {
          id
          name
        }
        location {
          id
          name
          patientArea
          locationType
          unit {
            id
            name
          }
        }
        assetDeviceType: deviceType {
          id
          name
        }
        assetTag {
          createdAt
        }
        imageId
      }
    }
  }
`

export const FacilityAssetsData = graphql(query, {
  options: props => ({
    variables: {
      facilityId: props.facilityId,
    },
    pollInterval: 300000, // 5 minutes; TODO: - get this value from GraphQL [NP-765]
  }),
  props: ({ data: { error, loading, facility }, ownProps }) => {
    if (error && error.networkError) {
      console.warn("Network error, not able to refresh")
      return
    }
    if (error) {
      throw error
    }
    if (loading) {
      return { loading }
    }
    if (!facility) {
      error = Error("No facility with id " + ownProps.facilityId + " available")
      error.number = 204
      throw error
    }

    return {
      allAssets: facility.assets,
      ...ownProps,
    }
  },
})

const FacilityAssetsWithData = FacilityAssetsData(FacilityAssets)

const mapStateToProps = ({ router }) => {
  const urlParams = qs.parse(router.location.search)

  return {
    keywords: urlParams.keywords,
    unitId: urlParams.unitId,
    departmentId: urlParams.departmentId,
  }
}

const FacilityAssetsWithStoreWithData = connect(mapStateToProps)(
  FacilityAssetsWithData
)

FacilityAssetsWithStoreWithData.propTypes = {
  facilityId: PropTypes.string.isRequired,
}

export default FacilityAssetsWithStoreWithData
